import { defineComponent as _defineComponent } from 'vue'

import type { PropOptions } from 'vue';

export const statusPillProps = {
  label: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: 'grey',
  },
} satisfies Record<string, PropOptions>;

export default /*#__PURE__*/_defineComponent({
  __name: 'StatusPill',
  props: statusPillProps,
  setup(__props) {



return { __sfc: true,statusPillProps }
}

})